var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as _ from "lodash";
import TenantPageConstants from "./TenantConstants.js";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
const getDefaultState = () => {
  return {
    workspaces: {
      status: AsyncRequestStatus.NotStarted,
      error: null,
      data: []
    },
    groups: {
      status: AsyncRequestStatus.NotStarted,
      error: null,
      data: []
    },
    currentGroup: {
      status: AsyncRequestStatus.NotStarted,
      error: null,
      data: null
    },
    userContext: {
      tid: null,
      workspaceId: null,
      experience: null,
      groupIdClassic: null,
      groupIdAzure: null,
      subscriptionId: null,
      selectedWorkspaceId: null
    }
  };
};
const TenantReducer = (state = getDefaultState(), actionResult) => {
  var _a, _b, _c, _d, _e;
  switch (actionResult.type) {
    case TenantPageConstants.SET_USER_CONTEXT:
      const userResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        userContext: userResult.payload
      });
    case TenantPageConstants.LOADING_WORKSPACES:
      return __spreadProps(__spreadValues({}, state), {
        workspaces: __spreadProps(__spreadValues({}, state.workspaces), {
          status: AsyncRequestStatus.Pending
        })
      });
    case TenantPageConstants.LOADED_WORKSPACES:
      const workspaceResult = actionResult;
      const workspaces = _.unionBy((_a = workspaceResult.payload) == null ? void 0 : _a.workspaces, state.workspaces.data, "id");
      return __spreadProps(__spreadValues({}, state), {
        workspaces: __spreadProps(__spreadValues({}, state.workspaces), {
          data: workspaces,
          status: AsyncRequestStatus.Completed
        })
      });
    case TenantPageConstants.LOADING_GROUPS:
      return __spreadProps(__spreadValues({}, state), {
        groups: __spreadProps(__spreadValues({}, state.groups), {
          status: AsyncRequestStatus.Pending
        })
      });
    case TenantPageConstants.LOADED_GROUPS:
      const result = actionResult;
      const groupWorkspace = result.payload.workspace;
      if (!!groupWorkspace) {
        const newState = __spreadProps(__spreadValues({}, state), {
          groups: __spreadProps(__spreadValues({}, state.groups), {
            data: (_b = result.payload) == null ? void 0 : _b.groups,
            status: AsyncRequestStatus.Completed
          })
        });
        if (!!groupWorkspace.name) {
          const match = _.find(newState.workspaces.data, (ws) => compareIgnoreCase(ws.id, groupWorkspace.id));
          if (!match) {
            (_c = newState.workspaces.data) == null ? void 0 : _c.push(groupWorkspace);
          } else if (!compareIgnoreCase(match.name, groupWorkspace.name)) {
            match.name = groupWorkspace.name;
          }
        }
        return newState;
      } else {
        return __spreadProps(__spreadValues({}, state), {
          groups: __spreadProps(__spreadValues({}, state.groups), {
            error: result.payload.error,
            status: AsyncRequestStatus.Failed
          })
        });
      }
    case TenantPageConstants.LOADING_CURRENT_GROUP:
      return __spreadProps(__spreadValues({}, state), {
        currentGroup: __spreadProps(__spreadValues({}, state.currentGroup), {
          status: AsyncRequestStatus.Pending
        })
      });
    case TenantPageConstants.LOADED_CURRENT_GROUP:
      let currentGroup = state.currentGroup.data;
      let result1 = actionResult;
      currentGroup = (_d = result1.payload) == null ? void 0 : _d.currentGroup;
      return __spreadProps(__spreadValues({}, state), {
        currentGroup: {
          status: AsyncRequestStatus.Completed,
          data: currentGroup,
          error: ""
        }
      });
    case TenantPageConstants.UPDATE_CURRENT_GROUP:
      return __spreadProps(__spreadValues({}, state), {
        currentGroup: __spreadProps(__spreadValues({}, state.currentGroup), {
          status: AsyncRequestStatus.Pending
        })
      });
    case TenantPageConstants.UPDATING_CURRENT_GROUP:
      return __spreadProps(__spreadValues({}, state), {
        currentGroup: __spreadProps(__spreadValues({}, state.currentGroup), {
          status: AsyncRequestStatus.Pending
        })
      });
    case TenantPageConstants.UPDATED_CURRENT_GROUP:
      let result3 = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        currentGroup: __spreadProps(__spreadValues({}, state.currentGroup), {
          data: (_e = result3.payload) == null ? void 0 : _e.newGroup,
          status: AsyncRequestStatus.Completed
        })
      });
    default:
      return state;
  }
};
export {
  TenantReducer,
  TenantReducer as default,
  getDefaultState
};
//# sourceMappingURL=TenantReducer.js.map
